import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { TokenService } from '../services/token.service';
import { SnackBarService } from '../shared/snack-bar.service';
import { PrimecapUtils } from '../utils/primecap-utils';

@Injectable({
  providedIn: 'root'
})
export class PermissoesUsuarioGuard  {
  constructor(
    private tokenService: TokenService,
    private snackBarService: SnackBarService) {}

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean> {
    return  this.verificarPermissoesDaRota(route);
  }
  canActivateChild(childRoute: ActivatedRouteSnapshot): Observable<boolean> {
    return this.verificarPermissoesDaRota(childRoute);
  }

  protected verificarPermissoesDaRota(route: ActivatedRouteSnapshot): Observable<boolean> {
    if (typeof route.data['roles'] !== undefined && route.data['roles'].length) {
      const permissoesRota = route.data['roles'];
      const permissoesUsuario = this.tokenService.carregarUsuarioLogado().permissoes;

      return new Observable<boolean>(result => {
        if (!PrimecapUtils.verificarPermissoesUsuario(permissoesRota, permissoesUsuario)) {
          result.next(false);
          this.snackBarService.exibirMensagem(`Acesso negado!`, true); //ou redirecionar para uma pagina
        } else {
          result.next(true);
        }
      });
    }

    return new Observable<boolean>(result => result.next(true));
  }


}
